import React from 'react';
import { Accordion } from 'components/accordion';
import ToolsItem from './tools-item';
import { ToolsItemProps } from './tools-item.type';

const UNKNOWN_ITEM = null;

export type ToolsProps = {
    content: ToolsItemProps[];
    activeItem?: number;
    toolsListRef?: React.RefObject<HTMLUListElement>;
};

export type ToolsElementProps = {
    children?: React.ReactNode | React.ReactNode[];
};

const ToolsElement = React.forwardRef<HTMLUListElement, ToolsElementProps>((props, ref) => {
    return (
        <ul className="tools" ref={ref} role="list">
            {props.children}
        </ul>
    );
});

const Tools: React.FC<ToolsProps> = ({ content, activeItem = UNKNOWN_ITEM, toolsListRef }) => {
    const [activeEventKey, setActiveEventKey] = React.useState(activeItem);
    const onToggleHandler = (index: number | null) => setActiveEventKey(index);
    const onToggle = (event: number) => onToggleHandler(event);
    const onCloseHandler = () => onToggleHandler(UNKNOWN_ITEM);

    React.useEffect(() => {
        if (typeof activeItem === 'number' && activeItem >= 0) {
            onToggleHandler(activeItem);
        }
    }, [activeItem]);

    return (
        <Accordion
            activeEventKey={activeEventKey}
            onToggle={onToggle}
            element={ToolsElement}
            elementRef={toolsListRef}
        >
            {content.map((item, index) =>
                item ? (
                    <ToolsItem
                        id={item.id}
                        index={index}
                        activeEventKey={activeEventKey}
                        onCloseHandler={onCloseHandler}
                        key={index}
                        {...item}
                    />
                ) : null
            )}
        </Accordion>
    );
};

export default Tools;
